export const PLATFORM_FEATURES = {
  TRACING_AI: 'tracing-ai',
  AUDIT_AI: 'audit-ai',
  AUTOMATION_RULES: 'automation-rules',
  CAPA_V2: 'capa-v2',
  CASCADE_TRACING: 'cascade-tracing',
  CASCADE_TRACING_COLLABORATION: 'cascade-tracing-collaboration',
  CERTIFIED_MATERIALS_MANAGEMENT: 'certified-materials-management',
  COMPANY_PROFILES: 'company-profiles',
  ENTITY_SCREENING_V2: 'entity-screening-v2',
  ITC_INTEGRATION: 'itc-integration',
  KHARON_ENTITY_LIST: 'kharon-entity-list',
  KHARON_V2: 'kharon-v2',
  PRODUCT_MAPPING: 'product-mapping',
  RISK_ANALYSIS_V3: 'risk-analysis-v3',
  SLCP_ASSESSMENT: 'slcp-assessment',
  SOCIAL_SCORE: 'social-score',
  SLCP_ACTIVE_HOST: 'slcp-active-host',
  SUPPLY_CHAIN_MAPPING_PRODUCT_STORY: 'supply-chain-mapping-product-story',
  VIEW_NETWORK_USERS_INFO: 'view-network-users-info',
  DROP_BOX: 'drop_box',
  SUPPLIER_QUESTIONNAIRE: 'supplier_questionnaire',
  ORDERS_HUB: 'order-hub',
  AUTOMATION_RULES_NL_DRAFT: 'automation-rules:nl-draft',
  PERMISSIONS_ACCESS: 'permissions:access',
  PERMISSIONS_CUSTOM_ROLES: 'permissions:custom-roles',
} as const;
